import React, { useState, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import "./auth.css"; 
import { AuthContext } from "../../context/AuthContext";
import AuthService from "../../services/auth.service";
import {useHistory} from 'react-router-dom'

const Signin = ({ handleChange }) => {
	const history = useHistory();
	const { isFetching, dispatch} = useContext(AuthContext);
	const [userInput, setUserInput] = useState("");
	const [password, setPassword] = useState("");

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (userInput === "") {
			return toast.error("Username or Email is required");
		}

		if (password === "") {
			return toast.error("Password is required");
		}

		await AuthService.login({ userInput, password }, dispatch, history);
	};

	return (
		<div className="auth__form__container">
			<Form className="mt-5">
				<Form.Group className="mb-4" controlId="formBasicEmail">
					<Form.Label className="form__input-label">
						Staff ID or Email address
					</Form.Label>
					<Form.Control
						className="form__input form__input__field"
						type="text"
						placeholder="Enter staff ID or email"
						value={userInput}
						onChange={(e) => setUserInput(e.target.value)}
					/>
				</Form.Group>

				<Form.Group className="mb-4" controlId="formBasicPassword">
					<Form.Label className="form__input-label">Password</Form.Label>
					<Form.Control
						className="form__input form__input__field"
						type="password"
						placeholder="Input work email password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</Form.Group>
				<Form.Group className="mb-4 form__flex" controlId="formBasicCheckbox">
					<Form.Text
						className="form__click__text click__forget"
						onClick={handleChange}
					>
						Forgot Password?
					</Form.Text>
				</Form.Group>
				<div className="d-grid gap-2">
					<Button
						className="auth__form__button form__input"
						size="lg"
						disabled={isFetching}
						onClick={handleSubmit}
						onKeyDown={handleSubmit}
					>
						{isFetching && <span className="spinner-border spinner-border-sm"></span>}
						<span>Sign in</span>
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default Signin;
